package com.arena_web.pages

import androidx.compose.runtime.Composable
import com.arena_web.ui.layouts.PageLayout
import com.arena_web.ui.sections.info.InfoBullet
import com.arena_web.ui.sections.info.InfoPageScaffold
import com.arena_web.ui.sections.info.InfoParagraph
import com.arena_web.ui.sections.info.InfoSection
import com.varabyte.kobweb.core.Page

@Page("/pricing")
@Composable
fun PricingPage() {
    PageLayout(
        title = "Pricing",
        description = "Arena Pro Play pricing — free to play, with optional Arena Coin packs for digital features.",
    ) {
        InfoPageScaffold(title = "Pricing") {
            InfoSection("Arena is free to play") {
                InfoParagraph(
                    "Creating an account, finding people nearby, joining and creating sports events, chatting, and " +
                        "tracking your player stats are all free. Optional digital features are unlocked with Arena " +
                        "Coins."
                )
            }
            InfoSection("Arena Coin packs") {
                InfoParagraph("Coin packs available on the web (prices in EUR):")
                InfoBullet("Starter — 100 coins — €4.99")
                InfoBullet("Popular — 500 coins — €19.99")
                InfoBullet("Premium — 1,500 coins — €49.99")
                InfoParagraph(
                    "Packs are purchased from your Wallet inside the app. Prices in the iOS and Android apps are " +
                        "set by the Apple App Store and Google Play and may differ slightly."
                )
            }
            InfoSection("What coins unlock") {
                InfoBullet("AI-generated player card avatars for your profile.")
                InfoBullet("Pro events with advanced features for organisers.")
                InfoParagraph(
                    "Coins are digital content usable only inside Arena Pro Play: they cannot be cashed out, " +
                        "transferred between users, traded, or exchanged. The current coin cost of each feature is " +
                        "always shown in the app before you confirm."
                )
            }
            InfoSection("Payments and taxes") {
                InfoParagraph(
                    "Prices are shown in euros (EUR). Payments are processed by our payment partners; depending on " +
                        "your card and country, your bank may convert the charge to your local currency, and " +
                        "applicable taxes may be reflected at checkout. See our Refund Policy for cancellations and " +
                        "refunds."
                )
            }
        }
    }
}
